<template>
  <div class="banner">
    <div class="teacher-box w-100 h-100 d-flex align-items-center">
      <div class="info-box">
        <div class="top">
          <h1 class="fw-bold">القيصر محمد طارق</h1>
          <p>
            يلا انضم لينا دلوقتي وابدأ رحلة تعليمية مختلفة فيها الشرح المبسط
            والتطبيق العملي. هنا مش هتتعلم الكيمياء وبس، دي كمان بتفهمها وتطبقها
            بكل سهولة
          </p>
        </div>
        <router-link :to="{ name: 'register' }" class="text-center">
          سجل معانا
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerComponent",
};
</script>

<style scoped>
.banner {
  height: 105vh;
  max-height: calc(105vh - 100px);
  min-height: calc(105vh + 40px);
  margin-top: -94px;
  background-image: url("../../assets/banner-bg.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}
body.dark .banner {
  background-color: #13323a;
}
.banner .teacher-box .info-box {
  width: 35%;
  margin: 0 10% 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3rem;
  color: #ffffff;
}
.banner .teacher-box .info-box .top {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.banner .teacher-box .info-box .top h1 {
  font-size: 3rem;
  font-weight: 900;
  margin: 0;
}
.banner .teacher-box .info-box .top p {
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0;
}
.banner .teacher-box .info-box a {
  all: unset;
  padding: 10px 50px;
  background-color: #dad2c5;
  color: #0d0d0d;
  text-align: center;
  border-radius: 0.625rem;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: 700;
  transition: all 0.5s;
}
.features-sub-footer > a:hover,
.banner .teacher-box .info-box a:hover {
  background-color: #ffffff;
}
/* Media Queries */
@media (max-width: 1200px) {
  .banner .teacher-box .info-box {
    margin-right: 10%;
  }
  .banner .teacher-box .teacher .teacher-image {
    max-width: 450px;
    max-height: 630px;
    margin-left: 10%;
  }
}
@media (max-width: 992px) {
  .banner {
    height: 100vh;
    max-height: 100vh;
    min-height: 100vh;
    background-position: 20%;
  }
  .banner .container {
    max-width: 100%;
    padding: 0;
  }
  .banner .teacher {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    z-index: 2;
    margin-bottom: 10%;
  }
  .banner .teacher-box {
    flex-direction: column-reverse;
    align-items: center;
    bottom: 25%;
  }
  .banner .teacher-box {
    width: 100% !important;
  }
  .banner .teacher-box .teacher .teacher-image {
    width: 200px;
    max-height: 400px;
    margin: 0;
  }
  .banner .teacher-box .info-box {
    margin-right: 0;
    width: 100%;
    align-items: center;
    padding-bottom: 3rem;
    gap: 1rem;
    background: linear-gradient(
      179.41deg,
      rgba(0, 0, 0, 0) 35.65%,
      #000000 83.6%
    );
  }
  .banner .teacher-box .info-box .top {
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1rem;
  }
  .banner .teacher-box .info-box .top h1 {
    font-size: 2rem;
  }
  .banner .teacher-box .info-box .top p {
    font-size: 1.25rem;
  }
  .banner .teacher-box .info-box a {
    padding: 10px 30px;
    font-size: 1.25rem;
  }
}
@media (max-width: 767px) {
  .banner .teacher-box .teacher .teacher-image {
    width: 225px;
    max-height: 420px;
    height: 100%;
  }
  .banner .teacher-box .info-box .top h1 {
    font-size: 1.75rem;
  }
  .banner .teacher-box .info-box .top p {
    font-size: 1.2rem;
  }
  .banner .teacher-box .info-box a {
    font-size: 1.2rem;
  }
}
@media (max-width: 568px) {
  .banner .teacher-box .info-box .top h1 {
    font-size: 1.5rem;
  }
  .banner .teacher-box .info-box .top p {
    font-size: 1rem;
  }
  .banner .teacher-box .info-box a {
    font-size: 1rem;
  }
}
</style>
